import { Auth } from 'aws-amplify';

async function getAuthToken() {
  const response = await Auth.currentSession();
  return response.getIdToken().getJwtToken();
}

async function getCustomHeader() {
  const prefix = 'Bearer ';
  return { Authorization: prefix + (await getAuthToken()) };
}

async function getCustomHeaderai() {
  // eslint-disable-next-line prefer-template
  return { Authorization: await getAuthToken() };
}

function getRedirectUrl() {
  const { origin, protocol, host, hostname } = window.location || {};
  const url = `${protocol}://${hostname || host}`;
  return `${origin || url}${origin.indexOf('localhost') > 0 ? '' : '/joynfsm/index.html'}`;
}

function getDomain() {
  const { REACT_APP_ENVIRONMENT } = process.env;
  const domain = REACT_APP_ENVIRONMENT === 'prod' ? '' : `-${REACT_APP_ENVIRONMENT}`;
  return `joyn2${domain}-sevenlakes-com.auth.us-west-2.amazoncognito.com`;
}

const awsregion = 'us-west-2';
const awsmobile = {
  aws_project_region: awsregion,
  aws_appsync_graphqlEndpoint: process.env.REACT_APP_GRAPHQL_URL,
  aws_appsync_region: awsregion,
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  Auth: {
    region: awsregion,
    userPoolId: process.env.REACT_APP_USERPOOL_ID,
    userPoolWebClientId: process.env.REACT_APP_USERPOOL_WEBCLIENTID,
  },
  API: {
    endpoints: [
      {
        name: 'IntegrationApi',
        endpoint: process.env.REACT_APP_INTEGRATION_URL,
        custom_header: getCustomHeader,
      },
      {
        name: 'FdgApi',
        endpoint: process.env.REACT_APP_FDG_API_URL,
        custom_header: getCustomHeaderai,
      },
    ],
  },
  adfsEnabled: true,
  usernameKey: 'custom:userid',
  adfs: {
    redirectURL: getRedirectUrl(),
    domain: getDomain(),
  },
};

// for joyn.ai builds
if (process.env.REACT_APP_ENVIRONMENT.includes('ai')) {
  awsmobile.usernameKey = 'email';
  awsmobile.Auth.cookieStorage = {
    // REQUIRED - Cookie domain (only required if cookieStorage is provided)
    domain: process.env.REACT_APP_COOKIE_DOMAIN,
    // OPTIONAL - Cookie path
    path: '/',
    // OPTIONAL - Cookie expiration in days
    expires: 30,
    // OPTIONAL - See: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie/SameSite
    sameSite: 'strict',
    // OPTIONAL - Cookie secure flag
    // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
    secure: false,
  };
}
export default awsmobile;
